<template>
	<div class="p4">
		<div>
			<div class="fs4 fw7 mb1">{{ $t("diagnosis_code") }}</div>
			<!-- Diagnosis Codes -->
			<search-general-codes
				codeName="diagnosisSettings"
				:productId="productId"
				v-model="form.diagnosisCodes"
			/>
		</div>

		<!-- Operation Codes -->
		<div class="mt4">
			<div class="fs4 fw7 mb1">{{ $t("operation_code") }}</div>
			<search-general-codes
				codeName="operationSettings"
				:productId="productId"
				v-model="form.operationCodes"
			/>
		</div>

		<!-- Provider Codes -->
		<div class="mt4">
			<div class="fs4 fw7 mb1">{{ $t("provider_code") }}</div>
			<search-provider-codes
				:productId="productId"
				v-model="form.providerCodes"
			/>
		</div>

		<!-- Button -->
		<div class="flex xs-left mt6">
			<j-button @click="onSubmit" :isLoading="isLoading">
				{{ $t("save") }}
			</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import SearchGeneralCodes from "./SearchGeneralCodes"
import SearchProviderCodes from "./SearchProviderCodes"
import api from "../api"

/**
 * This component is smart
 * It's reposnsible for rendering prepopulated form and updating data via API
 * When update is done it emits event up to the parent
 */
export default {
	components: {
		CoreFormInput,
		JButton,
		SearchGeneralCodes,
		SearchProviderCodes
	},

	props: {
		productId: {
			type: Object,
			default: () => ({
				operationCodes: [],
				diagnosisCodes: [],
				providerCodes: []
			})
		},
		claimId: {
			type: String,
			required: true
		},
		data: {
			type: Object,
			default: () => ({
				operationCodes: [],
				diagnosisCodes: [],
				provider: {}
			})
		}
	},

	data() {
		return {
			isLoading: false,
			form: {
				operationCodes: [],
				diagnosisCodes: [],
				providerCodes: []
			}
		}
	},

	methods: {
		async onSubmit() {
			if (!this.claimId) return

			this.isLoading = true
			const res = await api.updateClaim({
				claimId: this.claimId,
				input: {
					operationCodes: this.form?.operationCodes?.map(item => item.code),
					diagnosisCodes: this.form?.diagnosisCodes?.map(item => item.code),
					providerId: this.form?.providerCodes?.[0]?.id || null
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("updated")
			this.$modal.hide("updateCodes")
		}
	},

	created() {
		// Populate form from data prop
		// Manipulate it so that we can display `code - name` in the select box options
		this.form.diagnosisCodes = this.data.diagnosisCodes.map(item => ({
			name: `${item.code} - ${item.name}`,
			code: item.code
		}))

		this.form.operationCodes = this.data.operationCodes.map(item => ({
			name: `${item.code} - ${item.name}`,
			code: item.code
		}))

		if (this.data.provider && Object.keys(this.data.provider).length > 0)
			this.form.providerCodes.push({
				name: `${this.data?.provider?.internalCode} - ${this.data?.provider?.name}`,
				id: this.data?.provider?.id
			})
	}
}
</script>